<template>
  <div id="wallet" class="bg-light-grey">
    <!--<div class="fixed-top align-hor space-between padding-right-20 bg-blue text-light">
      <div class="text-large align-hor center-ver">
        <img class="back-btn padding-20" src="@/assets/back-light.png" alt="cash-reward" v-on:click="back">
        <div>Wallet</div>
      </div>
    </div>-->

    <div class="margin-5 margin-top-70 wallet-wrapper box-shadow radius-5">
      <div class="wallet-header-bg padding-10">
        <div class="align-hor center-ver space-between bg-grey margin-bottom-10">
          <div class="align-hor center-ver">
            <div>
              <img class="small-reward-icon" src="@/assets/notes.png" alt="cash-reward">
            </div>
            <div>
              <div>Balance</div>
              <div class="font-bold">₹{{totalEarnedCash}}</div>
            </div>
          </div>
          <div class="align-hor center-ver">
            <a v-if="isTRPending" class="text-small margin-right-10 text-underline" v-on:click="redirectTo('account', '')">See Account Details</a>
            <a class="install-invite no-text-decoration radius-3 box-shadow text-center text-semi-small" v-on:click="redirectTo('account', '')" v-if="isRedeemable">Redeem</a>
            <a class="install-invite btn-disabled text-light no-text-decoration radius-3 box-shadow text-center text-semi-small" v-else>Redeem</a>
          </div>
        </div>
        <div class="text-small" v-if="wallet_message != ''">{{wallet_message}}</div>
        <div class="wrapper" v-if="wallet_message == ''">
          <div class="comment animate"></div>
          <div class="margin-bottom-5"></div>
          <div class="comment animate"></div>
        </div>
      </div>
      <div class="bg-light padding-10">
        <div class="align-hor center-ver space-between">
          <p>Total Earned</p>
          <p>₹{{cash_earned}}</p>
        </div>
        <div class="align-hor center-ver space-between">
          <p>Total Redeemed</p>
          <p>₹{{cash_redeemed}}</p>
        </div>
      </div>
    </div>

    <div class="all-transactions">
      <div v-if="allTransactions.length">
        <div v-for="(transactions, $index) in allTransactions" :key="$index">
          <div class="transaction-bg padding-15 bottom-border" v-for="trans in transactions">
            <div class="align-hor space-between center-ver margin-bottom-5">
              <div class="">{{trans.type | capitalize}}</div>
              <div :class="[trans.is_credit ? 'text-green' : 'text-red']">+₹{{trans.amount}}</div>
            </div>
            <div class="align-hor space-between center-ver text-small">
              <div class="">#{{trans.id}}</div>
              <div class="">{{trans.earned_on}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="padding-15 bottom-border" v-for="$i in 7" :key="$i" v-else-if="showShimmer">
        <div class="wrapper">
          <div class="align-hor center-ver space-between">
            <div class="comment animate margin-bottom-5 w30"></div>
            <div class="comment animate margin-bottom-5 w20"></div>
          </div>
          <div class="align-hor center-ver space-between">
            <div class="comment animate margin-bottom-5 w15"></div>
            <div class="comment animate margin-bottom-5 w10"></div>
          </div>
        </div>
      </div>
    </div>
    <infinite-loading @infinite="infiniteScroll"></infinite-loading>
  </div>
</template>

<script>
  import { globals } from "@/mixins/globals"
  import axios from 'axios';
  export default {
    mixins: [globals],
    data() {
      return {
        page: 1,
        transactions: [],
        wallet_message: '',
        user_data: {
          user_accounts: [],
        },
        cash_earned: '',
        cash_redeemed: '',
        showShimmer: true,
      }
    },
    computed: {
      allTransactions: function() {
        return this.transactions;
      }
    },
    methods: {
      getWalletData(page, getWalletDataCallback) {
        var self = this;
        var url;
        var base_url = this.$store.getters.gamesDomain
        // var base_url = "http://localhost:3000"
        if(page == 1) {
          url = base_url + '/web_wallet';
        } else {
          url = base_url + '/web_cash_transactions';
        }

        url += '?partner='+self.partnerID+'&contact_number='+self.userPhone;

        if(self.gameID) {
          url += "&game_id="+self.gameID;
        }

        var headers = this.$store.getters.headers;
        return axios.get(url, {
          mode: 'no-cors',
          headers: headers,
          params: {
            page: self.page,
          }
        });
      },
      infiniteScroll($state) {
        var self = this;
        var page = self.page;
        axios.all(
          [self.getWalletData(page, null)]
        ).then(axios.spread((resp) => {
          if(resp.status == 200) {
            var data = resp.data;
            var tempArray = [];
            var tempObj = {};

            var all_cash_logs = data.all_cash_logs;

            if(self.page == 1) {
              self.$store.state.redeem = data.is_redeemable;
              self.$store.state.requestedTR = (data.hasOwnProperty("transfer_request") && !self.isEmpty(data.transfer_request));
              self.cash_earned = data.total_cash_earned;
              self.cash_redeemed = data.total_cash_redeemed;

              self.$store.state.user.cash = data.cash_balance;
              if(this.$ls.get("userData") != null) {
                var user_data = JSON.parse(this.$ls.get("userData"));
                user_data.cash = data.cash_balance;
                this.$ls.set('userData', JSON.stringify(user_data));
              }
              self.wallet_message = data.wallet_message;
            }

            if(all_cash_logs && all_cash_logs.length) {
              self.page += 1;
              all_cash_logs.forEach((cl) => {
                var is_credit = cl.is_earned ? true : false;
                var earned_on = self.timeAgo(cl.created_at)

                tempArray.push({
                  id: cl.id,
                  is_credit: is_credit,
                  type: cl.type,
                  amount: cl.amount,
                  earned_on: earned_on
                });
              });

              tempObj.user_accounts = data.user_accounts;
              self.user_data = tempObj;

              self.transactions.push(tempArray);
              $state.loaded();
            } else {
              self.showShimmer = false;
              $state.complete();
            }
          } else {
            console.log("Error fetching the wallet data");
          }
        })).catch((error) => {
          console.log("Catch block "+error);
          self.showShimmer = false;
          $state.complete();
        });
      },
    },
    created() {
      this.$store.state.headTitle = "Wallet";
      this.$store.state.showHeader = true;
      this.$store.state.showHistory = false;
      this.$store.state.showWallet = false;
      // if(!this.isUserLoggedIn) {
      //   this.redirectTo('', '');
      // }
    }
  }
</script>

<style>
  .small-reward-icon {
    width: 20px;
    margin-right: 5px;
  }

  .transaction-bg {
    background: #FFFFFF;
    margin-left: 5px;
    margin-right: 5px;
    box-shadow: 0 0 5px rgba(0,0,0,.2);
  }

  .wallet-header-bg {
    background: #F7F7F7;
  }
</style>


// WEBPACK FOOTER //
// src/screens/wallet.vue